import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import AnalyticsState, { ImpressionsParameter } from "@store/Store/Data/Analytics/AnalyticsState";
import { Draft } from "immer";

const initialState: AnalyticsState = {
    impressions: [],
};

const reducer = {
    "Store/Data/Analytics/SetImpression": (
        draft: Draft<AnalyticsState>,
        action: { impression: ImpressionsParameter },
    ) => {
        draft.impressions = [action.impression];
    },
    "Data/Pages/SetLocation": (draft: Draft<AnalyticsState>, action: { location: Location }) => {
        draft.impressions = [];
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
